/**
 * Markdown日志配置
 * 用于控制Markdown完整性检查的日志输出
 */

// 日志配置对象
export interface MarkdownLogConfig {
  // 是否启用日志
  enabled: boolean;
  // 日志级别，可扩展为更多级别
  level: 'none' | 'error' | 'warn' | 'info' | 'debug' | 'verbose';
}

// 默认配置
let logConfig: MarkdownLogConfig = {
  enabled: false, // 默认关闭日志
  level: 'info'
};

/**
 * 获取当前日志配置
 */
export const getLogConfig = (): MarkdownLogConfig => {
  return { ...logConfig };
};

/**
 * 启用Markdown日志
 * @param level 可选的日志级别
 */
export const enableMarkdownLog = (level: MarkdownLogConfig['level'] = 'info'): void => {
  logConfig.enabled = true;
  logConfig.level = level;
  console.log(`Markdown完整性检查日志已启用，级别: ${level}`);
};

/**
 * 禁用Markdown日志
 */
export const disableMarkdownLog = (): void => {
  logConfig.enabled = false;
  console.log('Markdown完整性检查日志已禁用');
};

/**
 * 设置日志配置
 * @param config 日志配置对象
 */
export const setLogConfig = (config: Partial<MarkdownLogConfig>): void => {
  logConfig = { ...logConfig, ...config };
  console.log(`Markdown日志配置已更新: ${JSON.stringify(logConfig)}`);
};

/**
 * 检查当前日志级别是否需要输出
 * @param level 要检查的日志级别
 */
export const shouldLog = (level: MarkdownLogConfig['level'] = 'info'): boolean => {
  if (!logConfig.enabled) return false;
  
  const levels = ['none', 'error', 'warn', 'info', 'debug', 'verbose'];
  const configIndex = levels.indexOf(logConfig.level);
  const levelIndex = levels.indexOf(level);
  
  // 当前配置级别要大于等于要输出的级别
  return configIndex >= 0 && levelIndex >= 0 && configIndex >= levelIndex;
}; 